import { LinkIcon } from '@heroicons/react/24/outline';

interface CopyLinkButtonProps {
  onClick: () => void;
  showText?: boolean;
}

export function CopyLinkButton({ onClick, showText = true }: CopyLinkButtonProps) {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 px-3 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded-md cursor-pointer"
    >
      <LinkIcon className="h-5 w-5" />
      {showText && 'Copy link'}
    </button>
  );
}
